import React, { useEffect, useState } from "react";
import Header from "../components/Header";
import Sidebar from "../components/Sidebar";
import Footer from "../components/Footer";
import {
  FaFilePdf,
  FaTimes,
  FaDownload
} from "react-icons/fa";
import Breadcrumb from "../components/Breadcrumb";

const Infrastructure = () => {
  const [open, setOpen] =
    useState(false);

  const [docs, setDocs] =
    useState([]);

  const [viewerOpen, setViewerOpen] =
    useState(false);

  const [selectedPdf, setSelectedPdf] =
    useState("");

  const [selectedTitle, setSelectedTitle] =
    useState("");

  useEffect(() => {
    fetch(
      " https://node.ilakshyaerp.in/api/infrastructure-documents"
    )
      .then((res) => res.json())
      .then((data) =>
        setDocs(
          Array.isArray(data)
            ? data
            : []
        )
      )
      .catch(() =>
        setDocs([])
      );
  }, []);

  /* DOWNLOAD */
  const handleDownload = async (
    file,
    title
  ) => {
    const url = ` https://node.ilakshyaerp.in/uploads/infrastructure/${file}`;

    const response =
      await fetch(url);

    const blob =
      await response.blob();

    const link =
      document.createElement("a");

    link.href =
      window.URL.createObjectURL(blob);

    link.download =
      title || file;

    document.body.appendChild(
      link
    );

    link.click();
    link.remove();
  };

  /* OPEN PDF */
  const openPdfViewer = (
    file,
    title
  ) => {
    setSelectedPdf(
      ` https://node.ilakshyaerp.in/uploads/infrastructure/${file}`
    );

    setSelectedTitle(title);
    setViewerOpen(true);
  };

  return (
    <>
      <Header
        toggleSidebar={() =>
          setOpen(true)
        }
      />

      <Sidebar
        isOpen={open}
        close={() =>
          setOpen(false)
        }
      />

      {/* HERO */}
      <div className="about-hero">
        <div className="about-overlay">
          <h1>
            INFRASTRUCTURE
          </h1>

          <p>
            Modern Campus With
            Quality Facilities
          </p>
          <Breadcrumb />
        </div>
      </div>

      {/* TOP INFO */}
      <div className="vision-card">
        <div id="faculty">

          <h3 className="table-section-heading">
            SCHOOL INFRASTRUCTURE DETAILS
          </h3>

          <div className="table-section-wrap">
            <table className="table-section faculty-table">

              <tbody>
                <tr>
                  <td>AREA OF SCHOOL IN SQUARE METRES</td>
                  <td>8100</td>
                  <td>AREA OF PLAYGROUND IN SQUARE METRES</td>
                  <td>7657</td>
                </tr>

                <tr>
                  <td>TOTAL BUILDING BLOCKS</td>
                  <td>2</td>
                  <td>NUMBER OF SITES</td>
                  <td>1</td>
                </tr>

                <tr>
                  <td>TOTAL NUMBER OF ROOMS</td>
                  <td>55</td>
                  <td>NUMBER OF WASHROOMS FOR FEMALE STAFF</td>
                  <td>4</td>
                </tr>

                <tr>
                  <td>NUMBER OF WASHROOMS FOR MALE STAFF</td>
                  <td>2</td>
                  <td>TOTAL NUMBER OF SMALL-SIZED ROOMS</td>
                  <td>00</td>
                </tr>

                <tr>
                  <td>TOTAL NUMBER OF MEDIUM-SIZED ROOMS</td>
                  <td>00</td>
                  <td>TOTAL NUMBER OF LARGE-SIZED ROOMS</td>
                  <td>02</td>
                </tr>

                <tr>
                  <td>NUMBER OF MALE STAFF ROOM</td>
                  <td>02</td>
                  <td>NUMBER OF FEMALE STAFF ROOM</td>
                  <td>02</td>
                </tr>

                <tr>
                  <td>TOTAL NUMBER OF LIBRARIES</td>
                  <td>01</td>
                  <td>TOTAL NUMBER OF PLAYGROUNDS</td>
                  <td>01</td>
                </tr>

                <tr>
                  <td>TOTAL NUMBER OF CANTEENS</td>
                  <td>00</td>
                  <td>NUMBER OF STAFF CANTEENS</td>
                  <td>00</td>
                </tr>

                <tr>
                  <td>NUMBER OF WATER PURIFIERS/ROs</td>
                  <td>02</td>
                  <td>NUMBER OF AUDITORIUMS</td>
                  <td>01</td>
                </tr>

                <tr>
                  <td>TOTAL NUMBER OF TOILETS</td>
                  <td>41</td>
                  <td>NUMBER OF GIRLS' TOILET</td>
                  <td>20</td>
                </tr>

                <tr>
                  <td>NUMBER OF BOYS' TOILET</td>
                  <td>13</td>
                  <td>NUMBER OF TOILETS FOR DIFFERENTLY ABLED</td>
                  <td>06</td>
                </tr>

                <tr>
                  <td>NUMBER OF LIFTS/ELEVATORS</td>
                  <td>00</td>
                  <td>NUMBER OF LABORATORIES</td>
                  <td>03</td>
                </tr>

                <tr>
                  <td>NUMBER OF ACTIVITY ROOMS</td>
                  <td>01</td>
                  <td>NUMBER OF GUARDS EMPLOYED FOR SAFETY</td>
                  <td>02</td>
                </tr>

                <tr>
                  <td>NUMBER OF SMART CLASSES</td>
                  <td>38</td>
                  <td>DOES YOUR SCHOOL HAS HOSTEL FACILITY?</td>
                  <td>Yes</td>
                </tr>

                <tr>
                  <td>NUMBER OF FIRE EXTINGUISHERS</td>
                  <td>25</td>
                  <td>NUMBER OF FIRE SPRINKLERS SYSTEM</td>
                  <td>08</td>
                </tr>

                <tr>
                  <td>NUMBER OF BUSES OWNED</td>
                  <td>10</td>
                  <td>NUMBER OF BUSES HIRED</td>
                  <td>0</td>
                </tr>

                <tr>
                  <td>NUMBER OF VANS/MATADORS</td>
                  <td>00</td>
                  <td>NUMBER OF DRIVERS</td>
                  <td>11</td>
                </tr>

                <tr>
                  <td>NUMBER OF VEHICLES AVAILABLE FOR STAFF</td>
                  <td>00</td>
                  <td>NUMBER OF PRIVATE CARS AVAILABLE</td>
                  <td>00</td>
                </tr>

                <tr>
                  <td>TRANSPORT COORDINATOR</td>
                  <td>Mr. Radhesyam Sharma</td>
                  <td>TRANSPORT COORDINATOR CONTACT</td>
                  <td>9839784021</td>
                </tr>

                <tr>
                  <td>ANY OTHER ACADEMIC ACTIVITY RUNNING ON CAMPUS?</td>
                  <td>NO</td>
                  <td>IS THE SCHOOL EXAMINATION CENTER OF CBSE?</td>
                  <td>YES</td>
                </tr>

                <tr>
                  <td>NUMBER OF COMPUTERS IN COMPUTER LAB</td>
                  <td>44</td>
                  <td>NUMBER OF WEB SERVERS IN SCHOOL</td>
                  <td>0</td>
                </tr>

                <tr>
                  <td>DOES YOUR SCHOOL HAS A BOUNDARY WALL?</td>
                  <td>YES</td>
                  <td>IS YOUR SCHOOL BARRIER FREE?</td>
                  <td>YES</td>
                </tr>

                <tr>
                  <td>DOES YOUR SCHOOL HAS CLINIC FACILITY?</td>
                  <td>NO</td>
                  <td>DOES YOUR SCHOOL HAS A STRONG ROOM?</td>
                  <td>YES</td>
                </tr>

                <tr>
                  <td>DOES YOUR SCHOOL HAS A GYMNASIUM?</td>
                  <td>NO</td>
                  <td>IS YOUR SCHOOL WI-FI ENABLED?</td>
                  <td>YES</td>
                </tr>

                <tr>
                  <td>PROVISION OF WEB BASED LEARNING PROGRAMS?</td>
                  <td>YES</td>
                  <td>DOES YOUR SCHOOL HAS FIRE ALARMS?</td>
                  <td>YES</td>
                </tr>

                <tr>
                  <td>DOES YOUR SCHOOL HAS SPORTS FACILITY?</td>
                  <td>YES</td>
                  <td>DOES YOUR SCHOOL HAS INDOOR GAMES FACILITY?</td>
                  <td>YES</td>
                </tr>

                <tr>
                  <td>DOES YOUR SCHOOL HAS A SWIMMING POOL?</td>
                  <td>NO</td>
                  <td>DOES YOUR SCHOOL HAS DANCE/MUSIC FACILITY?</td>
                  <td>YES</td>
                </tr>

                <tr>
                  <td>BUILDING SAFETY CERTIFICATE</td>
                  <td>VIEW</td>
                  <td>TRANSPORT SAFETY CERTIFICATE</td>
                  <td>VIEW</td>
                </tr>
              </tbody>
            </table>

          </div>

        </div>
      </div>

      <Footer />
    </>
  );
};

export default Infrastructure;